module.exports = __webpack_public_path__ + "static/media/project-tokens.a6544177.svg";